export const STATUS_LOADING   = 'loading'
export const STATUS_SUCCEEDED = 'succeeded'
export const STATUS_FAILED    = 'failed'

export const SORT_DESC = 'sortDesc'
export const SORT_ASC  = 'sortAsc'

export const MAX_RATE = 5

export const PATH_HOME       = '/'
export const PATH_PRODUCTS   = '/products'
export const PATH_CATEGORIES = '/categories'
export const PATH_CART       = '/cart'

export const PRODUCTS_IN_CART = 'products_in_cart'

export const EVENT_OPEN_SEARCH_MODAL = 'event_open_search_modal'

export const INPUT_SORTING = {
    'sortDesc': 'décroissant',
    'sortAsc': 'croissant',
}
